var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{ref:"viewer",staticClass:"ma-0 pa-0 mw-100",style:(_vm.viewerHeight),attrs:{"id":"webviewer"}})
}
var staticRenderFns = []

export { render, staticRenderFns }